import { Col, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';
import SkeletonCustom from './SkeletonCustom';

const Wrapper = styled.div`
   display: flex;
   flex-direction:column;
   align-items: center;
   margin-bottom: 10px;
   .line-width{width: 80%;}
   .right-text {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
   }
`;

const ArticleDrawerSkeleton = function AchievementSkeleton() {
  return (
    <Wrapper>
      <div className="concepts-margin w-100">
        <div>
          {[1, 2, 3, 4, 5, 6].map((index) => (
            <SkeletonCustom key={index} width="98%" height="230px" />
          ))}
        </div>
      </div>
      <div className="concepts-margin w-100 mr-0">
        <SkeletonCustom diameter="20px" margin="0px 0px 20px 0px" width="80%" height="28px" />
        <Row gutter={16}>
          <Col span={8}><SkeletonCustom width="100%" height="90px" /></Col>
          <Col span={8}><SkeletonCustom width="100%" height="90px" /></Col>
          <Col span={8}><SkeletonCustom width="100%" height="90px" /></Col>
        </Row>
      </div>
    </Wrapper>
  );
};

export default ArticleDrawerSkeleton;
